import React from 'react';

const FlowerLoader = ({ size = 64, fullScreen = false, className = '', overlayClassName = '' }) => {
  const spinner = (
    <img
      src="/images/web-images/flower2.svg"
      alt="Loading"
      className={`flower-loader-spin ${className}`.trim()}
      style={{ width: size, height: size }}
      draggable="false"
    />
  );

  if (!fullScreen) {
    return spinner;
  }

  return (
    <div className={`flower-loader-overlay ${overlayClassName}`.trim()}>
      {spinner}
    </div>
  );
};

export default FlowerLoader;
